import { getProgramFromPetInfoAndProducts } from '@app/shared/utils';
import { selectSelectedProducts } from '@app/store/products/products.selectors';
import { createSelector } from '@ngrx/store';
import { selectAllowanceParams } from './allowance-params.selectors';

/**
 * Selector for current program
 */
export const selectAllowanceCurrentProgram = createSelector(
  selectSelectedProducts,
  selectAllowanceParams,
  (products, params) =>
    !!products &&
    !!params.deprecatedPetInfo &&
    getProgramFromPetInfoAndProducts(products, params.deprecatedPetInfo, params.followUpAction?.targetProgram),
);
